// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-ccff8910] .el-form-item__content{\n  height: 29px!important;\n}\n[data-v-ccff8910] .bj-page .el-form-item__label{\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
